export const RESET_STATE = 'RESET_STATE';

//Usuario Action Types
export const SET_DADOS_USUARIO = 'SET_DADOS_USUARIO';
export const SET_PERMISSOES = 'SET_PERMISSOES';
export const SET_FILIAL = 'SET_FILIAL';
export const SET_REGIONAL = 'SET_REGIONAL';
export const SET_TODAS_REGIONAIS = 'SET_TODAS_REGIONAIS';